import React from 'react'; 
import '../../index.css';

const CompanyInfoCards = () => {
  const values = [
    { title: 'Quality', description: 'Compliance with the requirements and expectations of our clients.' },
    { title: 'Responsibility', description: 'The execution of the work depends on each of the elements that make up Maderas Estufadas del Guadiana.' },
    { title: 'Leadership', description: 'The ideal that the work is carried out properly and efficiently.' },
    { title: 'Honesty', description: 'Always with transparency and adequate communication with clients and interested parties.' },
    { title: 'Commitment', description: 'Carry out the projects with the best impetus and performance of the elements that make up Maderas Estufadas del Guadiana.' }
  ];

  const historyItems = [
    'Our history in the forestry industry in the city of Durango Durango, Mexico began more than 50 years ago.',
    'The founders of the company, the Chaidez Reyes Family, headed by Mr. Pedro Chaidez Varela, started serving the forestry market.',
    'Since 1995, we have been dedicated to the manufacture of export-quality pine wood moldings.',
    'Providing quality service in the production of custom wood moldings.',
    'We work to beautify your construction projects.'
  ];

  return (
    <div className="w-full max-w-6xl mx-auto p-6 space-y-8 bg-gray-100">
      {/* Historia */}
      <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200">
        <h2 className="text-2xl font-bold text-emerald-700 mb-6">Our History</h2>
        <div className="space-y-4">
          {historyItems.map((item, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-emerald-500" />
              <p className="text-gray-700 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Values Card */}
        <div className="bg-emerald-600 text-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-center mb-6">Values</h2>
          <div className="space-y-4">
            {values.map((value, index) => (
              <div key={index} className="space-y-2">
                <h3 className="font-semibold text-[#FDF7F4]">{value.title}</h3> {/* Color de letra actualizado */}
                <p className="text-sm text-emerald-50 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Mission Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <h2 className="text-2xl font-bold text-emerald-700 mb-6">Mission</h2>
          <p className="text-gray-700 leading-relaxed">
            To be the leading timber company that obtains the highest profitability
            in the industry through the export of excellent products and services, 
            optimizing resources and achieving international standards. To guarantee 
            that each productive activity is carried out with absolute safety for employees 
            and facilities. To grow and expand while respecting the environment, the community, 
            and ensuring sustainable development.
          </p>
        </div>

        {/* Purpose Card */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
          <h2 className="text-2xl font-bold text-emerald-700 mb-6">Purpose</h2>
          <p className="text-gray-700 leading-relaxed">
            Contribute to the well-being of the community by offering job opportunities
            within a framework of technical and human quality, providing a comprehensive
            service that meets the demands of the market while promoting environmental 
            conservation.
          </p>
        </div>
      </div>

      {/* Quality Policy */}
      <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
        <h2 className="text-2xl font-bold text-emerald-700 mb-6">Quality Policy</h2>
        <p className="text-gray-700 leading-relaxed">
          At Maderas Estufadas del Guadiana, we are committed to meeting the quality and 
          service requirements demanded by our clients in the forestry production and 
          export sector. This commitment is based on the principles, values, and technical 
          capabilities of our team, continuously improving our production processes, 
          infrastructure, and technology to achieve customer satisfaction. We aim to create 
          a safe and healthy work environment while complying with applicable legal requirements.
        </p>
      </div>
    </div>
  );
};

export default CompanyInfoCards;
